import React from 'react'
import Tilt from 'react-parallax-tilt'
import { motion } from 'framer-motion'

import SectionWrapper from './SectionWrapper'
import { projects } from '../const'
import { fadeIn, textVariant } from '../utils/motion'

const ProjectCard = ({ index, name, description, tags, image, source_code_link, source_image }) => {
    return (
        <motion.div variants={fadeIn('up', 'spring', index * 0.5, 0.75)}>
            <Tilt
                tiltMaxAngleX={45}
                tiltMaxAngleY={45}
                scale={1}
                transitionSpeed={450}
                className='bg-tertiary p-5 rounded-2xl sm:w-[360px] w-full'
            >
                <a
                    className='relative w-full h-[230px]'
                    href={source_code_link}
                    target='_blank'
                    rel='noopener noreferrer'
                    aria-label={`Open ${name} project link`}
                >
                    <img
                        src={image}
                        alt='project_image'
                        className='w-full h-full object-cover rounded-2xl'
                    />

                    <div className='absolute inset-0 flex justify-end m-3 card-img_hover'>
                        <div className='bg-white w-10 h-10 rounded-full flex justify-center items-center'>
                            <img
                                src={source_image}
                                alt='source code'
                                className='w-1/2 h-1/2 object-contain'
                            />
                        </div>
                    </div>
                </a>

                <div className='mt-5'>
                    <h3 className='text-white font-bold text-[24px]'>{name}</h3>
                    <p className='mt-2 text-secondary text-[14px]'>{description}</p>
                </div>

                <div className='mt-4 flex flex-wrap gap-2'>
                    {tags.map((tag) => (
                        <p key={`${name}-${tag.name}`} className={`text-[14px] ${tag.color}`}>
                            #{tag.name}
                        </p>
                    ))}
                </div>
            </Tilt>
        </motion.div>
    )
}

const Projects = () => {
    return (
        <>
            <motion.div variants={textVariant()}>
                <p className='sm:text-[18px] text-[14px] text-secondary uppercase tracking-wider'>
                    My work
                </p>
                <h2 className='text-pink md:text-[60px] sm:text-[50px] xs:text-[40px] text-[30px]'>
                    Projects.
                </h2>
            </motion.div>

            <div className='w-full flex'>
                <motion.p
                    variants={fadeIn('', '', 0.1, 1)}
                    className='mt-3 text-secondary text-[17px] max-w-3xl leading-[30px]'
                >
                    The following projects showcase my skills and experience through experimental
                    and real-world examples of my work. Each project is briefly described with
                    either a link to the GitHub repository or video walkthrough.
                </motion.p>
            </div>

            <div className='mt-20 flex flex-wrap gap-7'>
                {projects.map((project, index) => (
                    <ProjectCard key={`project-${index}`} index={index} {...project} />
                ))}
            </div>
        </>
    )
}

export default SectionWrapper(Projects, 'projects')
